import { jsx } from "panel";
import { SectionEl } from "common/components/section";
import { SvgIconEl } from "common/components/svg-icon";
const StringRow = ({ cmp, row }) => {
  return row.enum ? /* @__PURE__ */ jsx("select", {
    on: {
      change: ({ currentTarget: t }) => cmp.helpers.handleValueChanged(row, t.value)
    }
  }, row.enum.map((option) => /* @__PURE__ */ jsx("option", {
    attrs: { value: option, selected: row.value === option }
  }, option))) : /* @__PURE__ */ jsx("input", {
    attrs: { type: `text`, placeholder: row.default },
    props: { value: row.value },
    on: {
      input: ({ currentTarget: t }) => cmp.helpers.handleValueChanged(row, t.value)
    }
  });
};
const NumberRow = ({ cmp, row }) => {
  return /* @__PURE__ */ jsx("input", {
    attrs: { type: `number`, placeholder: row.default },
    props: { value: row.value },
    on: {
      input: ({ currentTarget: t }) => cmp.helpers.handleValueChanged(row, t.value)
    }
  });
};
const BooleanRow = ({ cmp, row }) => {
  return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("input", {
    attrs: { type: `checkbox` },
    props: { checked: row.value },
    on: {
      change: ({ currentTarget: t }) => cmp.helpers.handleValueChanged(row, t.checked)
    }
  }), `${row.value}`);
};
const JsonRow = ({ cmp, row }) => {
  const rowValue = JSON.stringify(row.value, null, ` `);
  const numLines = Math.min((rowValue.match(/\n/g) || []).length + 1, 5);
  return /* @__PURE__ */ jsx("textarea", {
    attrs: { rows: numLines, placeholder: row.default },
    class: { error: row.hasError },
    props: { value: rowValue },
    on: {
      input: ({ currentTarget: t }) => cmp.helpers.handleValueChanged(row, t.value)
    }
  });
};
export function template() {
  const { attrRows, eventRows, isExpanded } = this.state;
  const schema = this.getComponentSchema();
  return /* @__PURE__ */ jsx("div", {
    sel: ".auto-doc"
  }, /* @__PURE__ */ jsx(SectionEl, {
    attrs: {
      "header-title": `Docs for ${this.attr(`component`)}`,
      "is-closed": !isExpanded
    },
    on: { change: this.helpers.handleCollapsibleChange }
  }, isExpanded ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-table"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-titles"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-title-cell.attr"
  }, "Attribute"), /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-title-cell.type"
  }, "Type"), /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-title-cell.value"
  }, "Value"), /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-title-cell.description"
  }, "Description")), attrRows.map((row) => /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-row.attr",
    class: { changed: this.helpers.isValueChanged(row) }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-cell.attr"
  }, row.attr), /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-cell.type"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: this.helpers.ICON_FOR_TYPE[row.type] }
  }), row.tsType || row.type), /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-cell.value"
  }, row.type === `string` ? /* @__PURE__ */ jsx(StringRow, {
    cmp: this,
    row
  }) : row.type === `number` ? /* @__PURE__ */ jsx(NumberRow, {
    cmp: this,
    row
  }) : row.type === `boolean` ? /* @__PURE__ */ jsx(BooleanRow, {
    cmp: this,
    row
  }) : row.type === `json` ? /* @__PURE__ */ jsx(JsonRow, {
    cmp: this,
    row
  }) : null), /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-cell.description"
  }, row.description))), eventRows.length ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-titles"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-title-cell.event"
  }, "Event"), /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-title-cell.detail"
  }, "Detail"), /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-title-cell.console-log"
  }, /* @__PURE__ */ jsx("input", {
    attrs: { type: `checkbox` },
    props: { checked: this.helpers.areAllEventsLogged() },
    on: { change: this.helpers.toggleAllEventsLogging }
  }), "Log to Console"), /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-title-cell.when"
  }, "When")), eventRows.map((row) => /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-row.event",
    class: { logging: row.isLogging }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-cell.event"
  }, row.event), /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-cell.detail"
  }, row.detail || ``), /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-cell.console-log"
  }, /* @__PURE__ */ jsx("input", {
    attrs: { type: `checkbox` },
    props: { checked: row.isLogging },
    on: {
      change: ({ currentTarget: t }) => this.helpers.handleLoggingChanged(row, t.checked)
    }
  }), `${row.isLogging ? `Log Count: ${row.logCount}` : `Start Logging`}`), /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-cell.when"
  }, row.when || ``)))) : null, schema.props ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-titles"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-title-cell.prop"
  }, "Property"), /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-title-cell.tsType"
  }, "TsType"), /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-title-cell.description"
  }, "Description")), Object.keys(schema.props).map((propSchema) => /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-row"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-cell.prop"
  }, schema.props[propSchema]), /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-cell.tsType"
  }, schema.props[propSchema].tsType), /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-cell.description"
  }, schema.props[propSchema].description)))) : null, schema.slots ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-titles"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-title-cell.slot"
  }, "Slot"), /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-title-cell.description"
  }, "Description")), Object.keys(schema.slots).map((slotSchema) => /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-row"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-cell.slot"
  }, schema.slots[slotSchema]), /* @__PURE__ */ jsx("div", {
    sel: ".mp-table-cell.description"
  }, schema.slots[slotSchema].description)))) : null) : null));
}
